import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { type PaginationType } from "../types/filter";
import "./pagination.scss";

export const usePagination = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const pageIndex = useMemo(
    () => parseInt(searchParams.get("page") || "0", 10),
    [searchParams]
  );
  const pagination: PaginationType = useMemo(
    () => ({ page: pageIndex, size: 10 }),
    [pageIndex]
  );

  const setPage = (page: number) => {
    setSearchParams({ page: page.toString() });
  };

  return { pagination, setPage };
};

export const Pagination = ({
  pageIndex,
  maxPage,
  setPageIndex,
}: {
  pageIndex: number;
  maxPage: number;
  setPageIndex: (page: number) => void;
}) => {
  const start = Math.floor(pageIndex / 5) * 5;
  const end = Math.min(start + 5, maxPage);

  const pageNums = Array.from({ length: end - start }, (_, i) => start + i);

  return (
    <div className="pagination">
      <button
        onClick={() => setPageIndex(pageIndex - 1)}
        disabled={pageIndex <= 0}
      >
        <ChevronLeftIcon />
      </button>
      {pageNums.map((pageNum) => (
        <button
          key={pageNum}
          onClick={() => setPageIndex(pageNum)}
          className={pageNum === pageIndex ? "selected" : ""}
        >
          {pageNum + 1}
        </button>
      ))}
      <button
        onClick={() => setPageIndex(pageIndex + 1)}
        disabled={pageIndex + 1 >= maxPage}
      >
        <ChevronRightIcon />
      </button>
    </div>
  );
};
